import {
  Button,
  Backdrop,
  Box,
  Fade,
  Modal,
  Typography,
} from '@mui/material';
import ModalProps from '../../../interfaces/ModalProps';


const SubmitFeedbackSuccess = ({ open, handleClose }: ModalProps) => {
  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={open}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 1000,
        },
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            flexDirection: 'column',
            borderRadius: '12px',
            position: 'fixed',
            bgcolor: '#FFFFFF',
            boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.16)',

            top: '73px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '543px',
            padding: '24px',
            gap: '28px',
          }}
        >
          <Typography
            variant='h5'
            sx={{
              fontFamily: 'Schibsted Grotesk',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              letterSpacing: '0em',
              textAlign: 'left',
              color: '#181818',
              mt: '5px',
              mb: '20px',
            }}
          >
            Thank you for your feedback. Your insights are crucial to our
            ongoing process improvements.
          </Typography>

          <Box
            sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
          >
            {/* Cancel Button */}
            <Button
              variant='text'
              onClick={handleClose}
              // disabled={isLoading}
              sx={{
                width: 'fit-content',
                height: '44px',
                padding: '12px 36px',
                borderRadius: '6px',
                border: '1px solid #D1D1D1',
                fontFamily: 'Schibsted Grotesk',
                fontSize: '16px',
                fontWeight: 600,
                lineHeight: '20px',
                letterSpacing: '0em',
                textAlign: 'left',
                color: '#181818',
                textTransform: 'none',
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SubmitFeedbackSuccess;
